export default __webpack_public_path__ + "static/media/gm.bd16cc59.svg";